import { ChevronRightIcon } from '@radix-ui/react-icons'

import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

import { cx } from '@/lib/cva-config'

interface CardProfileProps {
  title: string
  children: React.ReactNode
  isRequired?: boolean
}

function CardProfile(props: CardProfileProps) {
  const { title, children, isRequired } = props

  return (
    <Card className="border-[#D3D6FF]">
      <CardHeader className="p-4 md:p-6">
        <CardTitle className="text-xl font-semibold tracking-wide">
          {title} {isRequired && <span className="text-red-500">*</span>}
        </CardTitle>
      </CardHeader>
      {children}
    </Card>
  )
}

function CardProfileContent(props: React.ComponentProps<typeof CardContent>) {
  const { className, ...rest } = props
  return (
    <CardContent
      className={cx(
        'grid grid-cols-4 gap-x-2 gap-y-6 p-4 !pt-0 md:grid-cols-6 md:p-6',
        className
      )}
      {...rest}
    />
  )
}

function CardProfileFooter(props: React.ComponentProps<typeof CardFooter>) {
  const { className, ...rest } = props
  return (
    <CardFooter
      className={cx('flex flex-wrap justify-end gap-2 p-4 md:p-6', className)}
      {...rest}
    />
  )
}

function CardProfileSubmissionButton(
  props: React.ComponentProps<typeof Button>
) {
  const { className, ...rest } = props
  return (
    <Button
      className={cx(
        'w-full rounded-xl bg-gradient-primary md:w-auto',
        className
      )}
      {...rest}
    >
      Simpan & Lanjutkan <ChevronRightIcon />
    </Button>
  )
}

CardProfile.Content = CardProfileContent
CardProfile.Footer = CardProfileFooter
CardProfile.SubmissionButton = CardProfileSubmissionButton

export { CardProfile }
